import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { Section, Reveal, Eyebrow, SectionTitle } from "./ui";
import { faqs } from "./data";
function Item({
  q,
  a,
  open,
  onClick
}: {
  q: string;
  a: string;
  open: boolean;
  onClick: () => void;
}) {
  return <div className="overflow-hidden rounded-2xl border border-[#e6eef5] bg-white" data-id="element-49" data-mp="1cgb8zfbaakg7">
      <button type="button" onClick={onClick} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left sm:px-6" aria-expanded={open} data-id="element-50" data-mp="2a0xjt1t3kxvr">
        <span className="text-sm font-bold text-[var(--ink)] sm:text-base" data-id="element-51" data-mp="202rhij3dppqd">{q}</span>
        <motion.span animate={{
        rotate: open ? 45 : 0
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-[var(--calm-blue)] text-[var(--accent)]" data-id="element-52" data-mp="1v5r9i2myycwm">
          <PlusIcon className="h-4 w-4" aria-hidden data-id="element-53" data-mp="1knzykcsau8ue" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-54" data-mp="1pmtc257l5zuk">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-55" data-mp="1pmbact25mtf9">
            <p className="px-4 pb-5 text-sm leading-relaxed text-[var(--muted)] sm:px-6" data-id="element-56" data-mp="11xihj5gtx1ov">{a}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section id="faq" className="bg-white" width="narrow" data-id="element-57" data-mp="s0vz0nbz6mq0">
      <Reveal className="text-center" data-id="element-58" data-mp="wxcqnridvj7u">
        <Eyebrow data-id="element-59" data-mp="wyfdnocl51ih">Preguntas frecuentes</Eyebrow>
        <SectionTitle data-id="element-60" data-mp="ixuwewmbjdr3">Lo que más nos preguntan</SectionTitle>
      </Reveal>

      <div className="mt-7 space-y-2.5 sm:mt-9" data-id="element-61" data-mp="mzyjkiico6s7">
        {faqs.map((f, i) => <Reveal key={f.q} delay={i * 0.03} data-id="element-62" data-mp="n22jyqh1innq" data-mpi={i}>
            <Item q={f.q} a={f.a} open={open === i} onClick={() => setOpen(open === i ? null : i)} data-id="element-63" data-mp="2pmwufj1pi15b" />
          </Reveal>)}
      </div>
    </Section>;
}